<template>
  <section>
    <h1 class="title">{{name}}</h1>
    <p>Working out can be intimidating. It’s normal to have goals and be unsure how to achieve them, and it’s completely normal to lack motivation at times.</p>
    <p>A experienced personal trainer can be invaluable,  as they can help you overcome your obstacles and take you to new heights on your fitness journey.</p>
    <p>All new clients are assessed to determine their goals, current levels of cardiovascular strength, muscle strength, coordination and core strength. </p>
    <p>Fisical Fitness is focused on helping clients achieve long-term results through challenging and varied workouts that involve strength training, cardiovascular work, functional training, core training and innovative stretching techniques.</p>
    <p>Consider these 6 benefits of hiring a personal trainer:</p>
    <ul>
      <h3 class="title">Education</h3>
      <li>        
        <p>A personal trainer will teach you everything you need to know about exercising. </p>
      </li>
      <h3 class="title">Motivation</h3>
      <li>        
        <p>Regular sessions with a personal trainer may give you the boost you need and having someone in your corner to push and encourage you can be rewarding. </p>
      </li>
      <h3 class="title">Accountability</h3>
      <li>        
        <p>A personal trainer will ensure that you stick to a fitness schedule gives you incentive to follow through and is the best way to achieve your goals.</p>
      </li>
      <h3 class="title">Challenging</h3>
      <li>        
        <p>A personal trainer will challenge you and take you to the next level. They will implement exercises to keep you off that plateau and introduce new exercises to keep your workouts fun with plenty of variety.</p>
      </li>
      <h3 class="title">Goals</h3>
      <li>        
        <p>Your personal trainer will start you out with small goals that will eventually lead to your final goal and show you exactly how to get there.</p>
      </li>
      <h3 class="title">Flexibility</h3>
      <li>        
        <p>Working with a trainer allows you the freedom to create your own workout schedule. Whether you prefer working out really early in the morning before work, on your lunch hour or late at night.</p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      name: "PERSONAL TRAINING"
    };
  }
};
</script>

<style scoped src="./PersonalTraining.css"></style>
